import { Router, Response, NextFunction } from 'express';
import multer from 'multer';
import fs from 'fs';
import path from 'path';
import { requireAuth, AuthRequest } from '../../middleware/auth.middleware';

const router = Router();

const storage = multer.diskStorage({
  destination: (req, file, cb) => {
    const userId = (req as AuthRequest).user?.sub;
    if (!userId) return cb(new Error('Unauthorized'), '');
    const dest = path.join(process.cwd(), 'uploads', userId);
    fs.mkdirSync(dest, { recursive: true });
    cb(null, dest);
  },
  filename: (req, file, cb) => {
    const uniqueSuffix = Date.now() + '-' + Math.round(Math.random() * 1E9);
    cb(null, uniqueSuffix + '-' + file.originalname);
  }
});

const upload = multer({ 
  storage,
  limits: { fileSize: 500 * 1024 * 1024 } // 500MB
});

router.post('/', requireAuth, upload.array('files'), (req: AuthRequest, res: Response, next: NextFunction) => {
  try {
    const files = req.files as Express.Multer.File[];
    if (!files || files.length === 0) {
      return res.status(400).json({ success: false, message: 'No files uploaded' });
    }

    const userId = req.user!.sub;
    
    // Return only the paths and metadata
    const uploadedFiles = files.map(file => ({
      name: file.originalname,
      mimeType: file.mimetype,
      size: file.size,
      storageUrl: `/uploads/${userId}/${file.filename}`,
      storageKey: file.filename
    }));

    res.status(201).json({ success: true, data: uploadedFiles });
  } catch (err) {
    next(err);
  }
});

export default router;
